import { floatingAiButtonTrackerPluginKey } from './floating-ai-button-tracker-plugin-key';
import { SafePlugin } from '../local-safe-plugin';
export const createAskAIButtonTrackerPlugin = options => {
  const {
    dispatch
  } = options;
  const initialState = {
    position: {
      from: 0,
      to: 0
    },
    shouldShowAskAIButton: false
  };
  return new SafePlugin({
    key: floatingAiButtonTrackerPluginKey,
    state: {
      init: (_, state) => initialState,
      apply: (tr, _pluginState, _oldEditorState, newEditorState) => {
        if (tr.selectionSet || tr.docChanged) {
          const {
            selection
          } = tr;
          const $currentNode = tr.doc.resolve(selection.from);
          const isEmptySelection = selection.empty;
          const {
            schema
          } = newEditorState;
          const {
            paragraph,
            heading
          } = schema.nodes;
          const shouldShowAskAIButton =
          // Only allowed for top level nodes
          $currentNode.depth === 1 && isEmptySelection && [paragraph, heading].includes($currentNode.node().type);
          const newPluginState = {
            position: {
              from: selection.from,
              to: selection.to
            },
            shouldShowAskAIButton
          };

          // We need to dispatch state change
          // As we use WithPluginState to enable/disable AI button.
          dispatch(floatingAiButtonTrackerPluginKey, newPluginState);
          return newPluginState;
        }
        return _pluginState;
      }
    }
  });
};